module.exports = __webpack_public_path__ + "img/phoneRight.d6c78275.png";